/* Sarah audit: preserve Shopify cart requests; never automatically repeat a POST. */
(() => {
  if (window.eosAuditBehaviorLoaded) return;
  window.eosAuditBehaviorLoaded = true;
  const locks = new WeakMap();
  const make = (tag, cls, text) => { const el = document.createElement(tag); el.className = cls; if (text) el.textContent = text; return el; };
  function freeze(form, after) {
    if (locks.has(form)) return;
    const saved = [];
    form.querySelectorAll('input,select,textarea,button').forEach(el => { if (!after.contains(el)) { saved.push([el, el.disabled]); el.disabled = true; } });
    locks.set(form, saved);
  }
  function prepareAgain(owner, form, clean) {
    (locks.get(form) || []).forEach(([el, disabled]) => el.disabled = disabled); locks.delete(form);
    if (clean) {
      form.reset();
      form.querySelectorAll('textarea').forEach(el => { el.value = ''; el.dispatchEvent(new Event('input', {bubbles:true})); });
      form.querySelectorAll('[name="id"][type="radio"]').forEach(el => el.checked = false);
      const charm = form.querySelector('[data-eos-charm]'); if (charm) charm.value = '';
      form.querySelectorAll('.eos-extra').forEach(el => el.open = false);
    }
    delete form.dataset.auditAddState;
    const submit = form.querySelector('button[type="submit"]'); submit.hidden = false; submit.disabled = false; submit.textContent = 'Add to cart';
    const status = form.querySelector('[data-eos-add-status]'); status.removeAttribute('data-error'); status.textContent = clean ? 'Choose the size and options for your next bracelet.' : 'Check your choices, then press Add to cart when you’re ready.';
    form.querySelector('[data-eos-after-add]').hidden = true;
    form.querySelector('[data-audit-uncertain]')?.remove();
    const total = form.querySelector('[data-eos-total]'); if (total) total.textContent = '';
    const first = form.querySelector('[name="id"][type="radio"]:not(:disabled)') || submit;
    first.focus({preventScroll:true}); first.closest('fieldset')?.scrollIntoView({block:'nearest'});
    owner.updatePrice(form);
  }
  async function cartSnapshot(owner, variant) {
    const abort = new AbortController(); const timer = setTimeout(() => abort.abort(),10000);
    try {
      const response = await fetch(owner.root + 'cart.js', {credentials:'same-origin',cache:'no-store',signal:abort.signal,headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count) || !Array.isArray(cart.items) || !Number.isFinite(cart.total_price) || !cart.currency) throw new Error('Incomplete cart');
      const same = cart.items.filter(item => String(item.variant_id || item.id) === String(variant)).reduce((n,item) => n + Number(item.quantity || 0),0);
      const total = new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:cart.currency,currencyDisplay:'code'}).format(cart.total_price / 100);
      owner.querySelectorAll('[data-eos-cart-count]').forEach(el => el.textContent = '(' + cart.item_count + ')');
      return 'This bracelet and size in your cart: ' + same + '. Cart: ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' (including any add-ons). Merchandise subtotal: ' + total + '.';
    } finally { clearTimeout(timer); }
  }
  customElements.whenDefined('eos-everyday-home').then(() => {
    const proto = customElements.get('eos-everyday-home').prototype;
    const originalURL = proto.resourceURL;
    proto.resourceURL = function(value,kind) {
      const url = originalURL.call(this,value,kind);
      if (kind === 'collections' && !url.searchParams.get('sort_by')) url.searchParams.set('sort_by','best-selling');
      return url;
    };
    const originalOpen = proto.openQuick;
    proto.openQuick = function(link) {
      if (this.hasAttribute('data-eos-collection-page')) {
        try { history.replaceState({...history.state,searchParams:location.search.slice(1)},'',location.href); } catch (_) {}
      }
      return originalOpen.call(this,link);
    };
    const originalClick = proto.onClick;
    proto.onClick = function(event) {
      const next = event.target instanceof Element ? event.target.closest('[data-eos-another]') : null;
      if (next && this.contains(next)) {
        event.preventDefault();
        this.closeQuick(true,() => {
          const guide = this.querySelector('[data-eos-guide]');
          if (guide) this.jump(guide); else location.assign(this.root + '?eos_start=guide');
        });
        return;
      }
      return originalClick.call(this,event);
    };
    const originalAdd = proto.add;
    proto.add = async function(form) {
      if (this.addBusy || form.dataset.auditAddState || !form.reportValidity()) return;
      const chosen = form.querySelector('[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
      const variant = chosen?.value, title = form.dataset.productTitle || 'Your bracelet', size = chosen?.dataset.title || '';
      const charm = form.querySelector('[data-eos-charm]');
      const charmName = charm?.value ? charm.selectedOptions[0].textContent.trim() : '';
      const hasMessage = !!form.querySelector('textarea[name="properties[Printed gift message]"]')?.value.trim();
      const status = form.querySelector('[data-eos-add-status]'), after = form.querySelector('[data-eos-after-add]'), submit = form.querySelector('button[type="submit"]');
      if (!variant || !status || !after || !submit) return;
      form.dataset.auditAddState = 'pending';
      try { const request = originalAdd.call(this,form); freeze(form,after); await request; }
      catch (_) { status.dataset.error = 'true'; status.textContent = 'We couldn’t confirm the addition. Check your cart before trying again.'; }
      const succeeded = !status.hasAttribute('data-error') && !after.hidden;
      form.dataset.auditAddState = succeeded ? 'added' : 'uncertain';
      submit.hidden = true; submit.disabled = true;
      if (!succeeded) {
        const box = make('div','eos-add-verification'); box.dataset.auditUncertain = '';
        const link = make('a','eos-btn eos-btn--outline','Check your cart'); link.href = this.root + 'cart';
        const retry = make('button','eos-text-link','I checked my cart — prepare to try again'); retry.type = 'button';
        retry.addEventListener('click',() => prepareAgain(this,form,false));
        box.append(link,retry); status.after(box); box.tabIndex = -1;
        if (this.dialog.open && this.panel.contains(form)) { box.focus({preventScroll:true}); box.scrollIntoView({block:'nearest'}); }
        return;
      }
      const added = 'Added 1 × ' + title + (size ? ' — ' + size : '') + '.';
      status.textContent = added;
      let detail = after.querySelector('[data-audit-added-detail]');
      if (!detail) { detail = make('p','eos-added-detail'); detail.dataset.auditAddedDetail = ''; after.prepend(detail); }
      detail.textContent = (charmName ? 'With ' + charmName + '. ' : '') + (hasMessage ? 'Your printed message is attached to this bracelet.' : '');
      detail.hidden = !detail.textContent;
      let snapshot = after.querySelector('[data-audit-cart-snapshot]');
      if (!snapshot) { snapshot = make('p','eos-cart-snapshot'); snapshot.dataset.auditCartSnapshot = ''; snapshot.setAttribute('role','status'); detail.after(snapshot); }
      snapshot.textContent = 'Updating your cart count and subtotal…';
      const keep = after.querySelector('[data-eos-close]');
      if (keep) { keep.classList.remove('eos-btn--outline'); keep.classList.add('eos-btn--solid'); }
      const next = after.querySelector('[data-eos-another]'); if (next) next.textContent = 'Find your next story';
      if (!after.querySelector('[data-audit-another]')) {
        const again = make('button','eos-text-link eos-add-deliberate','Choose this bracelet again'); again.type = 'button'; again.dataset.auditAnother = '';
        again.addEventListener('click',() => prepareAgain(this,form,true)); after.append(again);
      }
      after.tabIndex = -1;
      if (this.dialog.open && this.panel.contains(form)) { after.focus({preventScroll:true}); after.scrollIntoView({block:'nearest'}); }
      else this.feedback(added + ' Open your cart to see the updated quantities.');
      try {
        const text = await cartSnapshot(this,variant);
        if (form.dataset.auditAddState === 'added') snapshot.textContent = text;
        if (!this.dialog.open || !this.panel.contains(form)) this.feedback(added + ' ' + text);
      } catch (_) {
        if (form.dataset.auditAddState === 'added') snapshot.textContent = 'The addition succeeded, but the cart total could not refresh here. View your cart for the current quantities and subtotal.';
      }
    };
    const intent = new URL(location.href).searchParams.get('eos_start');
    if (intent === 'guide' || intent === 'browse') requestAnimationFrame(() => {
      const home = document.querySelector('eos-everyday-home:not([data-eos-collection-page])');
      const target = home?.querySelector(intent === 'guide' ? '[data-eos-guide]' : '.eos-browse');
      if (target && typeof home.jump === 'function') home.jump(target);
    });
  });
})();
